import React, { useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
} from '@mui/material';
import {
  VerifiedUser as CertificateIcon,
    Logout as LogoutIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const LoginHeader = () => {
  const [newTab, setNewTab] = React.useState(false);
  const navigate = useNavigate();

    useEffect(() => {
      const token = localStorage.getItem("authToken");
  
      if (token) {
        setNewTab(true)
      }
    }, []);
    
 
  const handleLogout = () => {
  localStorage.clear();

  // Trigger logout event for other tabs
  localStorage.setItem("logout", Date.now());

  // Redirect current tab
   window.location.reload()
};

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        background: 'linear-gradient(135deg, #00024c 0%, #1a2b6b 100%)',
        boxShadow: '0 2px 16px rgba(0, 2, 76, 0.2)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ minHeight: 72, px: 0 }}>
          {/* Brand/Logo Section */}
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              cursor: 'pointer',
              paddingY:1,
              '&:hover': {
                opacity: 0.9,
              },
              transition: 'opacity 0.3s ease',
            }}
            
          >
              <img src='/main/images/v1_9old.png' style={{width:'60px'}} alt="Logo" />
          </Box>

          {/* Navigation */}
          <Box sx={{ flexGrow: 1 }} />
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Button
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate('/main')}
              size='small'
              sx={{
                color: 'white',
                fontWeight: 500,
                textTransform: 'none',
                fontSize: '14px',
                px: 3,
                py: 1,
                borderRadius: 2,
                border: '1px solid rgba(255, 255, 255, 0.3)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  borderColor: 'rgba(255, 255, 255, 0.5)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Back to Home
            </Button>
            {newTab === false ? (
 <Button
              onClick={() => navigate('/main/register')}
              sx={{
                color: '#00024c',
                backgroundColor: 'white',
                fontWeight: 600,
                textTransform: 'none',
                fontSize: '14px',
                px: 3,
                py: 1,
                borderRadius: 2,
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(255, 255, 255, 0.3)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Register
            </Button>
            ) : (
                <Button
                            variant="outlined"
                            startIcon={<LogoutIcon />}
                            onClick={handleLogout}
                            sx={{
                              borderColor: 'rgba(255, 255, 255, 0.5)',
                              color: 'white',
                              backgroundColor: 'rgba(255, 255, 255, 0.1)',
                              backdropFilter: 'blur(10px)',
                              '&:hover': {
                                borderColor: 'white',
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                              },
                              transition: 'all 0.3s ease',
                              fontWeight: 600,
                            }}
                          >
                            Logout
                          </Button>
            )}
           
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default LoginHeader;
